var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.58093C5 7.22391 5 6.0454 5.73223 5.31317C6.46447 4.58093 7.64298 4.58093 10 4.58093H12.5C14.857 4.58093 16.0355 4.58093 16.7678 5.31317C17.5 6.0454 17.5 7.22391 17.5 9.58093V13.7476C17.5 16.1046 17.5 17.2831 16.7678 18.0154C16.0355 18.7476 14.857 18.7476 12.5 18.7476H10C7.64298 18.7476 6.46447 18.7476 5.73223 18.0154C5 17.2831 5 16.1046 5 13.7476V9.58093Z",
    stroke: "#ffffff",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.2476C3.61929 16.2476 2.5 15.1283 2.5 13.7476V8.7476C2.5 5.6049 2.5 4.03355 3.47631 3.05724C4.45262 2.08093 6.02397 2.08093 9.16667 2.08093H12.5C13.8807 2.08093 15 3.20022 15 4.58093",
    stroke: "#ffffff",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.075ff5d0b56e2c563e7713f723d24010.svg";
export { ForwardRef as ReactComponent };